// export const API_URL = "http://ec2-3-129-20-148.us-east-2.compute.amazonaws.com:3000"

export const API_URL = "https://api.electricsportshub.com";
// export const API_URL = "http://localhost:3000";